import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import TasksDataGrid from '../../components/Tasks/TasksDataGrid';
import FilterComponent from '../../components/Tasks/FilterComponent';
import ActionsButton from '../../components/Tasks/ActionsButton';

const TasksPage = () => {
  const [filters, setFilters] = useState(() => {
    const saved = localStorage.getItem("tasksFilters");
    try {
      const parsed = JSON.parse(saved);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    if (filters.length >= 0) {
      localStorage.setItem('tasksFilters', JSON.stringify(filters));
    }
  }, [filters]);

  const [triggerFetch, setTriggerFetch] = useState(false); // when deleting a row, refetching the data in datagrid
  const [selectedRows, setSelectedRows] = useState([]); // State to store selected row IDs

  // Function to handle row selection
  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection); // Store selected row IDs
  };

  useEffect(() => {
    document.title = "Tasks - iLead CRM";
  }, []);

  return (<>
    <Box sx={{ p: 2, height: '100%', display: 'flex' }}>
      <Grid container spacing={2} sx={{ height: '100%' }}>
        <Grid item xs={2.7} sx={{ height: '100%' }}>
          <Paper elevation={3} sx={{ height: 'calc(100vh - 105px)', p: 1, display: 'flex', flexDirection: 'column' }}>
            {/* Ensure FilterComponent also takes full height */}
            <FilterComponent filters={filters} setFilters={setFilters} sx={{ flex: 1, overflow: 'auto' }} />
          </Paper>
        </Grid>

        <Grid item xs={9.3} sx={{ height: '100%' }}>
          <Paper
            elevation={3}
            sx={{
              height: 'calc(100vh - 105px)',
              display: 'flex',
              flexDirection: 'column',
              p: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px',
              }}
            >
              <h3>Tasks</h3>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Link to="/tasks/create">
                  <Button variant="contained" type="submit">Create Task</Button>
                </Link>
                <ActionsButton itemIds={selectedRows} setSelectedRows={setSelectedRows} setTriggerFetch={setTriggerFetch} />
              </Box>
            </Box>

            <Box sx={{ flex: 1, overflow: 'hidden' }}>
              <TasksDataGrid
                filters={filters}
                selectedRows={selectedRows}
                triggerFetch={triggerFetch}
                setTriggerFetch={setTriggerFetch}
                onSelectionModelChange={handleSelectionChange} />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  </>
  )
};

export default TasksPage;
